<template>
  <div>
    <a-card style="width: 100%; margin-top: 10px; height: 570px">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        row-id="id"
        size="small"
        :row-config="{ height: 35, isCurrent: true, isHover: true }"
        ref="xTable"
        :data="tableData_detable"
        :loading="loading"
        class="my-sort"
        align="center"
        header-align="center"
        :row-style="rowStyle"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="ca" title="Cancer type" type="html"></vxe-column>
        <vxe-column field="r" title="PCC" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="p" title="P-value" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="plot" title="View" type="html">
          <template #default="{ row }">
            <a-tag
              color="purple"
              onmouseover="this.style.cursor='pointer'"
              @click="showPDF(row.ca)"
              >Explore</a-tag
            >
          </template>
        </vxe-column>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10, 20, 50]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-card>
    <a-modal
      :visible="this.simiplotModal"
      :maskClosable="true"
      :destroyOnClose="true"
      :keyboard="true"
      :closable="false"
      style="margin-top: 500px"
      :width="800"
      @ok="handleOk3"
      @cancel="handleCancel3"
      :cancel-button-props="{ props: { disabled: true } }"
    >
      <div slot="title">
        Scatter plot illustrating the correlation between Copy Number Variation
        and mRNA expression levels of
        <span style="color: red; font-size: bolder">{{ this.gene }}</span> in
        <span style="color: red; font-size: bolder">{{ this.selectCa }}</span>
      </div>
      <div slot="cancelText">
        <a-icon type="cloud-download" />
      </div>
      <a-spin size="large" :spinning="simiplot_visible" :indicator="indicator">
        <object :data="this.simiplotlinks" width="100%" height="480"></object>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
export default {
  props: ["ensgId", "gene", "selectCa"],
  name: "survival",
  created() {
    // 绘制图片
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/geneCancer/cnv.php", {
        params: {
          ensgId: this.ensgId,
          selectCa: this.selectCa,
        },
      })
      .then((response) => {
        this.getdata_detable = response.data.sort((a, b) => b.r - a.r);
        console.log(response.data);
        this.findList_detable(this.getdata_detable);
      });
  },
  methods: {
    rowStyle({ row }) {
      if (row.ca == this.selectCa) {
        return {
          backgroundColor: "#DB843D",
          color: "#ffffff",
        };
      }
    },
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    showPDF(v1) {
      this.simiplot_visible = true;
      this.simiplotlinks = "";
      this.simiplotModal = true;
      // 绘制图片
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/geneCancer/cnvplot.php",
          {
            params: {
              ensgId: this.ensgId,
              selectCa: v1,
            },
          }
        )
        .then((response) => {
          this.simiplot_visible = false;
          if (response.data != "failed") {
            this.simiplot_visible = false;
            this.$message.success(response.data + ".pdf plotted!", 6);
            this.simiplotlinks =
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
              response.data +
              ".pdf#zoom=70";
          } else {
            this.$message.error("step error, please contact us for a help!", 6);
          }
        });
    },
    handleOk3() {
      this.simiplotModal = false;
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "CNV-vs-mRNA_of_" + this.gene + "_in_TCGA",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: "CNV-vs-mRNA_of_" + this.gene + "_in_TCGA",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["ca"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        // 必须装回来
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
  },
  data() {
    return {
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      simiplot_visible: true,
      simiplotlinks: "",
      // gene: this.$route.query.gene,
      //配置
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      lowPercent: 50,
      highPercent: 50,
      cancerdemo: this.selectCa,
      cancerlist: [
        "ACC",
        "BLCA",
        "BRCA",
        "CESC",
        "CHOL",
        "COAD",
        "DLBC",
        "ESCA",
        "GBM",
        "HNSC",
        "KICH",
        "KIRC",
        "KIRP",
        "LAML",
        "LGG",
        "LIHC",
        "LUAD",
        "LUSC",
        "MESO",
        "OV",
        "PAAD",
        "PCPG",
        "PRAD",
        "READ",
        "SARC",
        "SKCM",
        "STAD",
        "TGCT",
        "THCA",
        "THYM",
        "UCEC",
        "UCS",
        "UVM",
      ],
      // 表格参数
      visible: false,
      // 基因个数
      value: 20,
      // plot
      simiplotModal: false,
      //加载
      loading: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: true,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
};
</script>
<style>
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
